import { render, staticRenderFns } from "./index-fixed.vue?vue&type=template&id=239d5286&scoped=true&"
import script from "./index-fixed.vue?vue&type=script&lang=js&"
export * from "./index-fixed.vue?vue&type=script&lang=js&"
import style0 from "./index-fixed.vue?vue&type=style&index=0&id=239d5286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d5286",
  null
  
)

export default component.exports